// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-container {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
}

.grid-square {
  position: absolute;
  border: 1px var(--border-style) var(--global-grey);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.grid-square span {
  font-size: var(--text-md);
  color: black;
  background: rgba(255, 255, 255, 0.4);
  padding: 2px 4px;
  border-radius: var(--box-rounding);
}

.active-square {
  border-color: var(--global-light);
  box-shadow: 0 0 5px var(--global-light);
}

@media (max-width: 1100px) {
  .grid-square span {
    font-size: var(--text-sm);
  }
}

@media (max-width: 800px) {
  .grid-square span {
    padding: 1px 2px;
    font-size: var(--text-sm);
  }
}

@media (max-width: 600px) {
  .grid-square span {
    font-size: var(--text-xs);
  }
}
`, "",{"version":3,"sources":["webpack://./src/ArtGrid/ImageDisplay/ImageDisplay.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".image-container {\n  position: relative;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.grid-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.grid-square {\n  position: absolute;\n  border: 1px var(--border-style) var(--global-grey);\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.grid-square span {\n  font-size: var(--text-md);\n  color: black;\n  background: rgba(255, 255, 255, 0.4);\n  padding: 2px 4px;\n  border-radius: var(--box-rounding);\n}\n\n.active-square {\n  border-color: var(--global-light);\n  box-shadow: 0 0 5px var(--global-light);\n}\n\n@media (max-width: 1100px) {\n  .grid-square span {\n    font-size: var(--text-sm);\n  }\n}\n\n@media (max-width: 800px) {\n  .grid-square span {\n    padding: 1px 2px;\n    font-size: var(--text-sm);\n  }\n}\n\n@media (max-width: 600px) {\n  .grid-square span {\n    font-size: var(--text-xs);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
